module.exports = __webpack_public_path__ + "static/media/icon_heart.6932ef22.svg";